<template>
  <div class="popup-overlay-container" @click.self="$emit('close')">
    <transition appear name="fade">
      <div class="popup-container">
        <div class="close-button" @click="$emit('close')">
          <CloseButtonImage />
        </div>
        <div class="popup-content-container">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CloseButtonImage from "@/assets/CloseButton.svg";
export default {
  name: "Popup",
  components: {
    CloseButtonImage,
  },
};
</script>

<style lang="scss" scoped>
.popup-overlay-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 2;

  .popup-container {
    display: flex;
    box-shadow: 0px 0px 20px 0px #0000001f;
    position: relative;

    .close-button {
      position: absolute;
      right: 20px;
      top: 20px;
      cursor: pointer;
      z-index: 1;
    }

    .popup-content-container {
      background: #ffffff;
      width: 400px;
      padding: 60px 20px 20px 20px;
      position: relative;
      border: 1px solid $gray;

      ::v-deep h1 {
        font-size: 18px;
        color: $green;
      }
    }
  }
}
</style>
